module.exports = __webpack_public_path__ + "img/c193dd6.webp";